module.exports = __webpack_public_path__ + "img/villa-img- (1).c124aa1b.png";